module.exports = __webpack_public_path__ + "fonts/Lora-Bold--9f29b0511c09bc963b6439efc1f21d4e.9f29b0511c09bc963b6439efc1f21d4e.ttf";